import { render } from "./BuyingPowerInfo.vue?vue&type=template&id=7c03b299&scoped=true"
import script from "./BuyingPowerInfo.vue?vue&type=script&lang=js"
export * from "./BuyingPowerInfo.vue?vue&type=script&lang=js"

import "./BuyingPowerInfo.vue?vue&type=style&index=0&id=7c03b299&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c03b299"]])

export default __exports__